module.exports = __webpack_public_path__ + "img/BCH.c803abf0.svg";